import { z } from "zod"
import { ResponsiveImage } from "../image"

export const introSchema = z.object({
  component: z.literal("intro"),
  title: z.string(),
  subtitle: z.string(),
})

type IntroProps = z.infer<typeof introSchema>

export default function IntroLanding(props: IntroProps) {
  const { title, subtitle } = props
  return (
    <>
      <div className="relative flex w-full justify-center pb-[35px] tablet:pb-[40px] desktop:pb-[55px]">
        <div className="pointer-events-none absolute left-0 top-0 w-full overflow-hidden px-4 tablet:-translate-y-[70px] desktop:left-[calc(50%-588px)] desktop:w-[1175px] desktop:px-0">
          <ResponsiveImage
            src="/ai-tools/index/intro"
            className="w-full desktop:w-[1175px]"
          />
        </div>

        <div className="relative mb-[35px] mt-[170px] flex w-full flex-col items-center justify-start tablet:mb-[40px] tablet:mt-[215px] desktop:mb-[55px] desktop:mt-[320px]">
          <div className="z-10 flex w-full flex-col items-center justify-start gap-4 desktop:w-[1175px]">
            <h2 className="text-h2 text-center">{title}</h2>
            <p className="text-body-2 tablet:max-w-[380px]a desktop:max-w-[448px]a text-center">
              {subtitle}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
